var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default h-100"},[(_vm.isLifeChamps)?_c('LifeChampsHeader'):_c('Header'),_c('v-main',[_c('v-container',{staticClass:"pb-0",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }